import React, { Component, useEffect } from "react";
import { hot } from "react-hot-loader";
import { Upload, Button, Icon, message, notification } from "antd";
import { handleError } from "../../utils/common";
import {
  UploadsApi,
  Upload as UploadType
} from "../../services/generated-sdk/";
import { AppContext } from "../../AppContext";
//import { Upload as UploadType } from "../../services/generated-sdk/models/Upload";
import { RcFile } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import "./uploads.css";
import * as _ from "lodash";
import Dragger from "antd/lib/upload/Dragger";
function GenericUploadButton(props) {
  const getDownloadURL = file => {
    //console.log('getDownloadURL')
    return process.env.API_BASE_URL + file.url;
  };
  const { company } = React.useContext(AppContext);
  const [filesList, setFilesList] = React.useState<UploadType[]>([]);
  const [files, setFiles] = React.useState<UploadFile[]>([]);
  const api = new UploadsApi();

  const valid = [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/zip",
    "application/rar",
    "application/pdf",
    "application/docx",
    "application/txt",
    "application/msword",
    "text/plain",
    "txt",
    "audio/mp3",
    "mp3",
    "mp4",
    "mpeg4",
    "MPG",
    "WEBM",
    "M4V",
    "docx",
    "xls",
    "jpeg",
    "xlsx",
    "csv",
    "odt",
    "ods",
    "svg",
    "application/x-zip-compressed",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/json",
    "text/html",
    "text/x-log",
    "application/sql",
    "text/xml",
    "text/x-patch",
    "image/gif",
    "application/vnd.ms-powerpoint",
    "application/vnd.oasis.opendocument.presentation",
    "application/rtf"
  ];

  useEffect(
    () => {
      if (!(props.value && props.value.length)) {
        // reset fields
        setFilesList([]);
        setFiles([]);
      }
    },
    [props.value]
  );

  const handleChange = info => {
    if (info.file.status === "uploading") {
      console.log("uploading..");
    }
    if (info.file.status === "done") {
      console.log("done..");
    }
  };

  //   const onBeforeFileUpload = (file: RcFile) => {
  //     let newList = filesList;
  //     newList[file.uid] = file;
  //     setFilesList(newList);
  //     props.setFileList(newList);
  //     return false;
  //   };

  //   const onFileRemove = file => {
  //     let newFileList = filesList;
  //     delete newFileList[file.uid];
  //     setFilesList(newFileList);
  //     props.setFileList(newFileList);
  //   };

  const setLoading = (loading = true) => {
    if (props.setImageLoading && typeof props.setImageLoading === "function")
      props.setImageLoading(loading);
    // alert("LOADING..........");
  };

  const uploadFilesCreated = async fileList => {
    try {
      let err = false;
      setLoading();
      const uploads = fileList.map(async file => {
        const splits = file.name.split(".");
        const ext = splits[splits.length - 1];
        if (!(valid.indexOf(file["type"]) > -1 || valid.indexOf(ext) > -1)) {
          // notification.warn({ message: "Invlid file format" });
          // err = true;
          return false;
        }
        const upload = await api.createUpload({
          files: file,
          company: company && company.id ? company.id : null
        });
        return upload;
      });
      await Promise.all(uploads).then(ups => {
        fileChanged(ups.map(u => u[0]));
      });
      // debugger;
      setLoading(false);
      // fileChanged(newList);

      return;
    } catch (e) {
      // setLoading(false);
      console.log(e);
      handleError(e.status);
    }
  };

  const onFileRemove = file => {
    try {
      const fileToRemove = _.find(filesList, { name: file.name });
      if (fileToRemove) {
        return api.deleteUpload({ id: fileToRemove.id }).then(status => {
          if (status) {
            let newList = [...filesList];
            let newfiles = [...files];
            const updatednewList = _.reject(newList, { id: fileToRemove.id });
            const updatednewfiles = _.reject(newfiles, { uid: file.uid });
            setFiles(updatednewfiles);
            if (props.onFilesRemoved) {
              const ids = updatednewList.map(f => f.id).filter(f => !!f);
              props.onFilesRemoved(ids);

              if (props.onChange) props.onChange(ids);
              return true;
            }
            fileChanged(updatednewList);
            return true;
          }
          return false;
        });
      }
    } catch (e) {
      console.log({ error: e });
      handleError(e.status);
      return false;
    }
  };

  const fileChanged = uploads => {
    const fileIds = uploads.map(f => f.id);
    setFilesList(filesList.concat(uploads));

    if (props.onChange) props.onChange(fileIds);
    if (props.setFileList) {
      props.setFileList(fileIds);
    }
    if (props.setFiles) {
      props.setFiles(uploads);
    }
  };

  const beforeUpload = (file, filesList) => {
    try {
      const showUploadList =
        props.showUploadList === undefined ? true : props.showUploadList;
      let filtered = filesList.filter(fileRecord => {
        const splits = fileRecord.name.split(".");
        const ext = splits[splits.length - 1];
        if (
          !(valid.indexOf(fileRecord["type"]) > -1 || valid.indexOf(ext) > -1)
        ) {
          notification.warn({
            message: "Invalid file format " + fileRecord.name
          });
          // err = true;
          return false;
        }
        return true;
      });
      if (showUploadList) setFiles([...filtered, ...files]);

      if (
        filtered &&
        filtered.length &&
        file &&
        filtered[filtered.length - 1].uid === file.uid
      ) {
        uploadFilesCreated(filtered);
      }
    } catch (e) {
      console.error({ beforeUpload_error: e });
      console.error({ file, filesList });
    }
    return false;
  };
  return (
    <div
      onDragOver={event => {
        event.stopPropagation();
      }}
    >
      <Upload.Dragger
        disabled={props.disabled === true}
        name="files"
        accept=".jpg, jpeg, .png, .docx, .doc, .txt, .gif, .zip, .webp, .mp4, .mp3, .pdf, .xls, .jpeg,  .xlsx,  .csv,  .odt,  .ods,  .svg"
        multiple={props.multiple}
        onRemove={onFileRemove}
        fileList={files}
        showUploadList={
          props.showUploadList === undefined ? true : props.showUploadList
        }
        beforeUpload={beforeUpload}
        onChange={info => {
          console.log({ info });
        }}
      >
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">Click or drag file here to upload</p>
      </Upload.Dragger>
    </div>
  );
}

export default hot(module)(GenericUploadButton);
